import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconContextSearch24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconContextSearch24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.25 7.25c0 .414.336.75.75.75h14.25a.75.75 0 0 0 0-1.5H4a.75.75 0 0 0-.75.75m0 10c0 .414.336.75.75.75h5.62a.75.75 0 0 0 0-1.5H4a.75.75 0 0 0-.75.75M17.5 13.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.5 0c0 .692-.201 1.338-.548 1.88l1.58 1.591a.75.75 0 1 1-1.064 1.058l-1.574-1.585A3.5 3.5 0 1 1 19 13.5M4 13a.75.75 0 0 1 0-1.5h4.815a.75.75 0 0 1 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconContextSearch24);
